<template>
  <el-container class="container" id="elContainer">
    <el-aside width="208px" id="elAside">
      <vue-scroll :ops="ops">
        <div class="logo">充电桩后台管理</div>
        <Nav-Menu></Nav-Menu>
      </vue-scroll>
    </el-aside>
    <el-container>
      <el-header>
        <content-header></content-header>
      </el-header>
      <el-main
        id="elMain"
        :class="this.$route.name === '系统首页' ? 'main-index' : ''"
      >
        <vue-scroll :ops="ops">
          <div class="main-wrapper" :style="this.$route.name === '系统首页' ? 'opacity:0' : ''">
            <router-view :key="key"></router-view>
          </div>
        </vue-scroll>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import NavMenu from "@/components/nav-menu";
import contentHeader from "@/components/header";
import navBreadcrumb from "@/components/breadcrumb";
export default {
  components: { NavMenu, contentHeader, navBreadcrumb },
  data() {
    return {
      ops: {
        vuescroll: {},
        rail: {}
      }
    };
  },
  computed: {
    key(val) {
      console.log(this.$route.name);
      if (this.$route.name === "系统首页") {
        console.log(val);
      }
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.red {
  background: red;
}
</style>
